import { FileSpreadsheet, ExternalLink } from 'lucide-react'
import { QueryRawSqlUsecaseTableResult } from 'poc-ai-biz-irdb_domain-model'

export type SourceDocumentQueryRawSqlUsecaseTableCardPropsContent = {
  result: QueryRawSqlUsecaseTableResult
  displayName: string
  queryDescription: string
  spreadsheetSheetUrl: string | null
}

export type SourceDocumentQueryRawSqlUsecaseTableCardProps = SourceDocumentQueryRawSqlUsecaseTableCardPropsContent & {
  onClick: () => void
}

/**
 * QueryRawSqlUsecaseTableResultをUIカード表示用のプロパティに変換する
 *
 * @param queryRawSqlUsecaseTableResult - 生SQLクエリの実行結果
 * @returns UIカード表示用のプロパティ（onClickは含まない）
 */
export const mapToSourceDocumentQueryRawSqlUsecaseTableCardContent = (
  queryRawSqlUsecaseTableResult: QueryRawSqlUsecaseTableResult,
): SourceDocumentQueryRawSqlUsecaseTableCardPropsContent => {
  return {
    result: queryRawSqlUsecaseTableResult,
    displayName: queryRawSqlUsecaseTableResult.queryTitle,
    queryDescription: queryRawSqlUsecaseTableResult.queryDescription,
    spreadsheetSheetUrl: queryRawSqlUsecaseTableResult.spreadsheetSheetUrl,
  }
}

export const SourceDocumentQueryRawSqlUsecaseTableCard: React.FC<SourceDocumentQueryRawSqlUsecaseTableCardProps> = ({
  displayName,
  queryDescription,
  spreadsheetSheetUrl,
  onClick,
}) => {
  const isClickable = spreadsheetSheetUrl !== null

  return (
    <button
      onClick={onClick}
      disabled={!isClickable}
      className={`block p-3 border border-gray-200 rounded-md bg-white text-left transition-colors ${
        isClickable ? 'hover:bg-blue-50 hover:border-blue-300 cursor-pointer' : 'cursor-not-allowed opacity-60'
      }`}
    >
      <div className="flex items-start gap-2">
        <FileSpreadsheet className="h-4 w-4 text-green-600 mt-0.5 flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="text-sm font-medium text-gray-800">{displayName}</div>
          <div className="text-xs text-gray-500 mt-1">{queryDescription}</div>
          {spreadsheetSheetUrl && (
            <div className="text-xs text-blue-600 mt-1 flex items-center gap-1">
              <ExternalLink className="h-3 w-3" />
              <span>Google Sheetsで開く</span>
            </div>
          )}
        </div>
      </div>
    </button>
  )
}
